import { ICropping, IField, OmniaObjectType } from "../omnia"

export function getFieldActivity(create: boolean, field: IField) {

    return {
        action: create ? "c" : "u",
        resourceId: field.FieldId,
        resourceType: OmniaObjectType.Field,
        data: { Name: field.Name, Area: field.CroppingArea }
    }

}

export function getCroppingActivity(create: boolean, cropping: ICropping) {

    const field = cropping.Field

    return {
        action: create ? "c" : "u",
        resourceId: cropping.CroppingId,
        resourceType: OmniaObjectType.Cropping,
        data: {
            YearId: cropping.YearId,
            Area: cropping.Area,
            Crop: {
                Name: cropping.Crop?.Name
            },
            Field: {
                Name: field.Name,
                Area: field.CroppingArea
            }
        }
    }
}
